/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_Th1Inputs */

const en_mk_cmp_notion_th1 = /** @type {(inputs: Mk_Cmp_Notion_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You build the database yourself; the firmness depends on team discipline.`)
};

const id_mk_cmp_notion_th1 = /** @type {(inputs: Mk_Cmp_Notion_Th1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda menyusun sendiri basis datanya; ketegasannya bergantung pada disiplin tim.`)
};

/**
* | output |
* | --- |
* | "You build the database yourself; the firmness depends on team discipline." |
*
* @param {Mk_Cmp_Notion_Th1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_th1 = /** @type {((inputs?: Mk_Cmp_Notion_Th1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_Th1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_th1(inputs)
	return en_mk_cmp_notion_th1(inputs)
});